const leadPreferences = {
  leadPreferences: {
    pageHeader: 'Preferencje dotyczące potencjalnych klientów',
    confirmMessage:
      'Czy na pewno chcesz zapisać preferencje dotyczące potencjalnych klientów i przejść do strony dodawania użytkownika?',
    notInterested: {
      radioOptions0: 'Brak czasu/zasobów na obsługę nowych potencjalnych klientów',
      radioOptions1: 'Tylko zainteresowani podpisanymi umowami z właścicielami domów',
      radioOptions2: 'Nie chcę ujawniać przedziału cenowego',
      radioOptions3: 'Inne',
      selectReason: 'Wybierz powód rezygnacji z programu Enphase dot. potencjalnych klientów',
      otherComments: 'Inne komentarze'
    },
    programOverview: {
      notInterestedText:
        'W tej chwili nie jesteśmy zainteresowani uczestnictwem w programie Enphase dot. potencjalnych klientów'
    },
    serviceDetailsSection: {
      min: 'Min.',
      max: 'Maks.',
      maxLessMin: 'Wartość maksymalna nie może być równa lub mniejsza od wartości minimalnej',
      enterInRange: 'Wprowadź liczbę z zakresu od %{serviceMInValue} do %{serviceMaxValue}',
      note: 'Uwaga!',
      noteText:
        'Na podstawie tych danych właścicielowi domu zostanie zaprezentowany przedział cenowy. Cena ta powinna zawierać podatki, ale nie świadczenia motywacyjne.',
      noteTextAus:
        'Na podstawie tych danych właścicielowi domu zostanie zaprezentowany przedział cenowy. Cena ta powinna zawierać VAT, ale nie świadczenia motywacyjne.',
      sizeRange: 'Zakres wielkości',
      pricePerkWh: 'Cena za kWh',
      lessThan20kWh: 'Poniżej 20 kWh',
      greaterThan20kWh: '20–40 kWh'
    },
    serviceAreaSection: {
      title: 'Dostęp administratora i obszar usług',
      manageAdminAccess: 'Zarządzaj dostępem administratora',
      addNewUser: '+ Dodaj nowego użytkownika',
      selectOneAdmin:
        'Wybierz jednego administratora z Twojej firmy, który będzie osobą upoważnioną do kontaktu na wypadek, gdyby firma Enphase chciała się z Tobą skontaktować w sprawach związanych z potencjalnymi klientami.',
      selectUser: 'Wybierz użytkownika',
      otherAdmin:
        '#Inni administratorzy z powyższej listy nadal będą otrzymywać alerty i wiadomości dotyczące wszystkich nowych potencjalnych klientów. W razie potrzeby mogą je wyłączyć, aktualizując swoje preferencje powiadomień.',
      serviceArea: 'Obszar usług',
      addServiceAreas: ''
    },
    addUserDialog: { yes: 'Tak' },
    acModule: {
      optIn: 'Zgoda na instalację modułów fotowoltaicznych AC Energized Enphase',
      description:
        'Właściciel domu wyraża zainteresowanie systemem opartym na modułach AC. Dostarczysz i zainstalujesz moduły AC. Moduły fotowoltaiczne AC Energized Enphase łączą w sobie najnowocześniejszą technologię mikroinwerterową firmy Enphase z wysokowydajnymi panelami słonecznymi. Produkt wyróżnia się estetyką i wydajnością. Ponadto skraca czas instalacji poprzez połączenie inwertera i panelu w pojedynczy zespół.'
    },
    sampleQuotes: {
      title: 'Orientacyjne ceny dla potencjalnych klientów',
      useSlider:
        'Użyj poniższych suwaków, aby zobaczyć, jak dane wejściowe dotyczące przedziału cenowego przekładają się na orientacyjny przedział cenowy dla właścicieli domów w kontekście różnych rozmiarów systemu',
      description:
        'Na podstawie Twoich danych wejściowych zostanie wyświetlony orientacyjny przedział cenowy, który zobaczą właściciele domów. Możesz również sprawdzić, jak przedział cenowy będzie się różnić w zależności od wielkości systemu.',
      solarOnly: 'Instalacja systemu fotowoltaicznego',
      storageOnly: 'Instalacja systemu magazynowania energii',
      solarStorage: 'Instalacja systemu fotowoltaicznego + magazynowania energii',
      solarExpansion: 'Rozbudowa systemu fotowoltaicznego',
      turnkeyACM: 'Instalacja systemu magazynowania energii + modernizacja modułu AC',
      microUpgrade: 'Modernizacja mikroinwerterów',
      turnkeyIQSeries: 'Instalacja systemu magazynowania energii + modernizacja mikroinwerterów',
      installationACM: 'Instalacja systemu magazynowania energii + modernizacja modułu AC',
      installationIQSeries: 'Instalacja systemu magazynowania energii + modernizacja mikroinwerterów',
      installationSolar: 'Instalacja systemu fotowoltaicznego',
      installationStorage: 'Instalacja/rozbudowa systemu magazynowania energii',
      turnkeyNew: 'Cena za kompleksową instalację dla nowych właścicieli domów',
      turnKeyExisting: 'Cena za kompleksową instalację dla już istniejących właścicieli domów',
      turnkeyNewUS: 'Cena za kompleksową instalację dla właścicieli domów',
      installationUS: 'Cena za samą instalację dla właścicieli domów',
      installation: 'Wycena za samą instalację dla kupujących mikroinwerter M-190',
      turnkeyPrice: 'Cena za kompleksową instalację',
      installation2: 'Cena za samą instalację dla klientów z polecenia',
      installation3: 'Cena za samą instalację',
      microinverterFootnote: 'Cena modernizacji mikroinwerterów może zostać dodana w zależności od wieku lokalizacji',
      solar: 'Energia słoneczna',
      storage: 'Magazynowanie'
    },
    operationMaintenance: {
      label: 'Zgoda na świadczenie usług operacyjnych i konserwacyjnych',
      description:
        'Usługi operacyjne i konserwacyjne obejmują wsparcie i serwisowanie istniejących systemów Enphase oraz systemów osieroconych (lokalizacji z nieaktywnym instalatorem). Wszyscy potencjalni klienci zainteresowani usługami operacyjnymi i konserwacyjnymi otrzymają pełne informacje o lokalizacji i historię wsparcia. Wszystkich potencjalnych klientów zainteresowanych usługami operacyjnymi i konserwacyjnymi obowiązuje standardowa gwarancja produktowa firmy Enphase. Poprzednia gwarancja na wykonanie nie miała zastosowania do systemów osieroconych.'
    },
    leadProgram: {
      optIn: 'Zgłoś się do programu Enphase dot. potencjalnych klientów',
      description:
        'Właściciele domów kontaktują się z firmą Enphase w sprawie nowych instalacji, modernizacji i bieżącej konserwacji systemu. Jako partner Enphase masz teraz możliwość obsługiwania tych właścicieli domów w ramach programu Enphase dot. potencjalnych klientów (Enphase Leads Program).',
      programHighlights: 'Najważniejsze punkty programu:',
      keyTerms1: 'Enphase bezpłatnie zapewni kwalifikujących się potencjalnych klientów z Twojego obszaru usług',
      keyTerms2:
        'Profil klienta i szczegóły projektu zostaną podane dla każdego potencjalnego klienta przed pierwszym kontaktem',
      keyTerms3: 'Enphase pomoże w planowaniu, umówieniu spotkania, aktualizowaniu projektu i wsparciu technicznym',
      keyTerms4:
        'Od instalatorów wymaga się udzielenia odpowiedzi każdemu potencjalnemu klientowi, skontaktowania się z nim i przesłania oferty w ciągu 2 dni roboczych',
      keyTerms5: 'W ramach programu należy stosować wyłącznie produkty Enphase',
      leadProgramPreferences: 'Preferencje programu dot. potencjalnych klientów',
      someLeads:
        'Niektórzy potencjalni klienci mogą potrzebować tylko usług instalacyjnych. Wskaż poniżej, czy wyrażasz zgodę na kontakt z takimi potencjalnymi klientami.',
      tooltipTitle1:
        'Usługi świadczone na rzecz właścicieli domów. Enphase przypisze Cię do właścicieli domów na podstawie wybranych przez Ciebie preferencji usług',
      turnKey: 'Usługi pod klucz',
      tooltipTitle2: 'Zapewniasz cały sprzęt, projekt, zezwolenia i usługi instalacyjne',
      installationService: 'Tylko usługi instalacyjne',
      tooltipTitle3:
        'Właściciel domu decyduje się na zakup sprzętu Enphase w sklepie Enphase. Zapewniasz resztę sprzętu, projekt, zezwolenia i usługi instalacyjne',
      solarNew: 'Energia słoneczna – nowe instalacje',
      solarUpgrades: 'Energia słoneczna – modernizacje',
      storageNew: 'Magazynowanie energii – nowe instalacje'
    },
    textContent: {
      preference: {
        title: 'Preferencje programu dot. potencjalnych klientów',
        caption: 'Wyłączenie odpowiedzialności',
        description:
          'Firma Enphase przedstawi właścicielom domów zakres cen podany przez Ciebie dla każdej z poniższych preferencji. Zostanie on przedstawiony z zastrzeżeniem, że wycena ma charakter informacyjny i odzwierciedla zakres prac tylko dla typowego systemu. Rzeczywista cena może ulec zmianie w zależności od lokalizacji, rodzaju/nachylenia dachu, standardu panelu elektrycznego i przeniesienia systemu w inne miejsce.​',
        atleaseOne: '* wybierz co najmniej jedną usługę'
      },
      programreview: {
        title: 'Przegląd programu',
        description:
          'Właściciele domów kontaktują się z firmą Enphase w sprawie nowych instalacji, modernizacji i bieżącej konserwacji systemu. Jako partner Enphase masz teraz możliwość obsługiwania tych właścicieli domów w ramach programu Enphase dot. potencjalnych klientów. Zapoznaj się z poniższymi kluczowymi warunkami i określ swoje preferencje dotyczące programu.'
      },
      keyProgramTerms: {
        title: 'Kluczowe warunki programu',
        enphaseProduct: 'W ramach programu należy stosować wyłącznie produkty Enphase',
        appointment: 'Firma Enphase pomoże w umawianiu spotkań i zapewni wsparcie w razie potrzeby',
        contact:
          'Od instalatorów wymaga się nawiązania kontaktu z każdym potencjalnym klientem w ciągu 2 dni roboczych',
        project:
          'Profil klienta i szczegóły projektu zostaną podane dla każdego potencjalnego klienta przed pierwszym kontaktem',
        verifiedAccount: 'Enphase bezpłatnie zapewni kwalifikujących się potencjalnych klientów z Twojego obszaru usług'
      },
      TurnKey: {
        title: 'Usługi kompleksowe',
        description:
          'Usługi kompleksowe oznaczają, że instalator zapewnia zestawienie materiałowe, projekt, zezwolenia, instalację i uruchomienie (w zależności od potrzeb). Instalator wykonuje projekt i dokonuje oceny lokalizacji przed dostarczeniem szczegółowej wyceny. Podana cena powinna zawierać całkowity szacunkowy koszt aktywacji systemu, jaki poniesie właściciel domu.',
        solar: {
          indicativePricing: 'Orientacyjny zakres cen za 1 W',
          quoteSizeIn: 'kW',
          main: 'System fotowoltaiczny – instalacja',
          sub: 'Nowa instalacja systemu fotowoltaicznego.',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Instalator',
              sub:
                'Zapewnia wycenę systemu gotowego do użytku i wymagane zestawienie materiałów, takich jak moduły, mikroinwertery (lub alternatywnie moduły AC), skrzynka IQ Combiner, zestaw akcesoriów, wyłączniki, modem komórkowy, kable i stelaże.'
            },
            assumptions: {
              main: 'Założenia',
              sub:
                'Przedział cenowy dotyczy typowej lokalizacji i nie obejmuje modernizacji panelu głównego i nietypowego dachu.'
            }
          }
        },
        storage: {
          indicativePricing: 'Orientacyjny zakres cen za 1 kWh',
          indicativePricingStorageSlabs: 'Orientacyjna cena za kWh',
          main: 'System magazynowania energii – instalacja',
          quoteSizeIn: 'kWh',
          sub: 'Nowa instalacja systemu magazynowania energii',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Instalator',
              sub:
                'Zapewnia wycenę systemu gotowego do użytku i wszystkie wymagane zestawienia materiałowe, takie jak system magazynowania energii Encharge, przełącznik Enpower, modem komórkowy, zestaw akcesoriów i kable.'
            },
            assumptions: {
              main: 'Założenia',
              sub: 'Orientacyjny przedział cenowy nie obejmuje modernizacji panelu głównego.'
            }
          }
        },
        microinverter: {
          indicativePricing: 'Orientacyjny zakres cen za 1 W',
          main: 'Mikroinwerter – modernizacja',
          quoteSizeIn: 'kW',
          sub:
            'Modernizacja mikroinwertera instalacji fotowoltaicznej opartej na serii M (np. M-215, M-250) do nowej instalacji fotowoltaicznej opartej na serii IQ, która zwykle towarzyszy opcji "System magazynowania energii – instalacja"',
          sub2:
            'Modernizacja mikroinwertera instalacji fotowoltaicznej opartej na serii M (np. M-215, M-250) do nowej instalacji fotowoltaicznej opartej na serii IQ',
          subUS:
            'Modernizacja mikroinwertera instalacji fotowoltaicznej w celu przekształcenia jej w instalację fotowoltaiczną opartą na mikroinwerterach serii IQ.',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Instalator',
              sub: 'Zapewnia wycenę systemu gotowego do użytku i wszystkie wymagane zestawienia materiałowe.'
            },
            assumptions: {
              main: 'Założenia',
              sub:
                'Orientacyjny przedział cenowy nie obejmuje modernizacji panelu głównego i modernizacji panelu słonecznego.'
            }
          }
        }
      },
      installationOnly: {
        title: 'Tylko usługi instalacyjne (dla programów specjalnych)',
        titleUS: 'Tylko usługi instalacyjne',
        sub: '(np. właściciele domów z panelami słonecznymi opartymi na M-190, przyjaciele i rodzina Enphase)',
        description:
          'Usługi tylko w zakresie instalacji oznaczają, że właściciel domu nabywa pozycje zestawienia materiałowego Enphase ze sklepu Enphase. Wszystkie inne materiały i usługi zapewnia bezpośrednio instalator (okablowanie, stelaże, projektowanie, zezwolenia, instalacja i uruchomienie, jeśli dotyczy).',
        solar: {
          quoteSizeIn: 'kW',
          indicativePricing: 'Orientacyjny zakres cen za 1 W za samą instalację',
          main: 'System fotowoltaiczny – instalacja',
          sub:
            'Nowa instalacja do programów specjalnych lub pełna modernizacja instalacji fotowoltaicznej opartej na urządzeniach M-190/M-210/M-175/D380',
          subUS: 'Instalacja nowego systemu fotowoltaicznego',
          details: {
            homeOwner: {
              main: 'Właściciel domu',
              sub:
                'Kupuje wymagane pozycje zestawienia materiałowego ze sklepu Enphase, takie jak moduły AC, skrzynka Combiner IQ, zestaw akcesoriów i wyłączniki.'
            },
            installer: {
              main: 'Instalator',
              sub: 'Zapewnia stelaże, okablowanie, zezwolenia, instalację i uruchomienie.'
            },
            assumptions: {
              main: 'Założenia',
              sub:
                'Orientacyjny przedział cenowy nie obejmuje modernizacji panelu głównego i instalacji na nietypowym dachu.'
            }
          }
        },
        storage: {
          quoteSizeIn: 'kWh',
          indicativePricing: 'Orientacyjny zakres cen za 1 kWh za samą instalację',
          indicativePricingStorageSlabs: 'Orientacyjna cena za 1 kWh za samą instalację',
          main: 'System magazynowania energii – instalacja',
          sub:
            'Dodatkowy system magazynowania energii do już istniejącego systemu fotowoltaicznego dla specjalnych programów lub do systemu fotowoltaicznego opartego na urządzeniach M-190/M-210/M-175/D380',
          subUS: 'Nowa instalacja systemu magazynowania energii',
          details: {
            homeOwner: {
              main: 'Właściciel domu',
              sub:
                'Nabywa wymagane pozycje zestawienia materiałowego ze sklepu Enphase, takie jak system magazynowania energii Encharge, przełącznik Enpower czy zestaw akcesoriów, brama Envoy (w razie potrzeby skrzynka IQ Combiner, modem komórkowy i/lub przekładnik prądu).'
            },
            installer: {
              main: 'Instalator',
              sub: 'Zapewnia zezwolenia, instalację i uruchomienie.'
            },
            assumptions: {
              main: 'Założenia',
              sub: `Orientacyjny przedział cenowy nie obejmuje modernizacji panelu głównego.`
            }
          }
        },
        microinverter: {
          quoteSizeIn: 'kW',
          indicativePricing: 'Orientacyjny zakres cen za 1 W za samą instalację',
          main: 'Mikroinwertery – modernizacja',
          sub: `Modernizacja mikroinwerterów instalacji fotowoltaicznej opartej na urządzeniach M-190/M-210/M-175/D380 do nowej instalacji fotowoltaicznej opartej na serii IQ, która zwykle towarzyszy opcji "System magazynowania energii – instalacja”`,
          sub2:
            'Modernizacja mikroinwertera instalacji fotowoltaicznej opartej na serii M (np. M-215, M-250) do nowej instalacji fotowoltaicznej opartej na serii IQ',
          subUS:
            'Modernizacja mikroinwertera instalacji fotowoltaicznej w celu przekształcenia jej w instalację fotowoltaiczną opartą na mikroinwerterach serii IQ.',
          details: {
            homeOwner: {
              main: 'Właściciel domu',
              sub:
                'Nabywa wymagane pozycje zestawienia materiałowego ze sklepu Enphase, takie jak mikroinwertery, skrzynka Combiner IQ, zestaw akcesoriów i wyłączniki.​'
            },
            installer: {
              main: 'Instalator',
              sub: 'Zapewnia zezwolenia, wymianę, ponowne uruchomienie i recykling starych mikroinwerterów.​'
            },
            assumptions: {
              main: 'Założenia',
              sub: `Orientacyjny przedział cenowy nie obejmuje modernizacji panelu głównego i zmian w stelażu.`
            }
          }
        }
      },
      omServices: {
        title: 'Usługi operacyjne i konserwacyjne Enphase',
        om: {
          main: 'Zgoda na świadczenie usług operacyjnych i konserwacyjnych Enphase',
          pre: '- Including Orphan Systems',
          sub: `Usługi operacyjne i konserwacyjne obejmują wsparcie i serwisowanie istniejących systemów Enphase oraz systemów osieroconych (lokalizacji z nieaktywnym instalatorem). Wszyscy potencjalni klienci zainteresowani usługami operacyjnymi i konserwacyjnymi otrzymają pełne informacje o lokalizacji i historię wsparcia. Wszystkich potencjalnych klientów zainteresowanych usługami operacyjnymi i konserwacyjnymi obowiązuje standardowa gwarancja produktowa firmy Enphase. Poprzednia gwarancja na wykonanie nie miała zastosowania do systemów osieroconych.`
        }
      },
      otherServices: {
        title: 'Pozostałe preferencje',
        buy: 'Jesteśmy zainteresowani kupnem produktów od',
        acModule: {
          main: 'Jesteśmy zainteresowani instalowaniem modułów fotowoltaicznych AC Energized firmy Enphase',
          sub1: `Panele fotowoltaiczne AC Energized firmy Enphase `,
          sub2: `łączą w sobie najnowocześniejszą technologię mikroinwerterową firmy Enphase z wysokowydajnymi panelami słonecznymi. Produkt wyróżnia się estetyką i wydajnością. Ponadto skraca czas instalacji poprzez połączenie inwertera i panelu w pojedynczy zespół. Wybór tej opcji sprawi, że firma Enphase dopasuje Cię do właścicieli domów, którzy chcą zainstalować moduły AC.`
        },
        enstore: {
          main: 'Sklep Enphase',
          sub1: `Sklep Enphase `,
          sub2: `to punkt kompleksowej obsługi produktów do produkcji i magazynowania energii słonecznej, z gwarantowaną dostawą. Sklep nie wymaga minimalnej kwoty zamówienia i zapewnia informacje dotyczące dostawy w czasie rzeczywistym oraz śledzenie online.`,
          subIndia: `to punkt kompleksowej obsługi produktów do produkcji energii słonecznej, z gwarantowaną dostawą. Sklep nie wymaga minimalnej kwoty zamówienia i zapewnia informacje dotyczące dostawy w czasie rzeczywistym oraz śledzenie online.`
        },
        distributor: {
          main: 'Dystrybutorzy Enphase',
          sub1: `Dystrybutorzy Enphase`,
          sub2: ` zapewniają wszystkie produkty firmy Enphase i inne akcesoria niezbędne dla Twojego systemu produkcji i magazynowania energii słonecznej.`,
          subIndia: ` zapewniają wszystkie produkty firmy Enphase i inne akcesoria niezbędne dla Twojego systemu produkcji energii słonecznej​`
        },
        permitAssistance: {
          main: 'Jesteśmy zainteresowani usługą pomocy w uzyskaniu zezwolenia od Enphase',
          sub: `Enphase pomoże Ci w zdobyciu zezwoleń dotyczących produkcji i magazynowania energii słonecznej dla Twoich lokalizacji, które będzie można następnie przedłożyć władzom lokalnym do zatwierdzenia.`
        },
        financeProvider: {
          // TODO - new translations added
          main: 'Zapewniamy właścicielom domów opcje finansowania',
          // TODO ends
          no: 'Nie',
          yes: 'Tak',
          financeProvider: 'Dostawcy usług finansowych',
          others: 'Inni dostawcy',
          addMultiple: 'maks. 3 (oddzielić przecinkami)',
          requiredSelection: 'Wymagany wybór',
          atLeastOneError: `Nieprawidłowi dostawcy usług finansowych (wprowadź przynajmniej jedną nazwę dostawcy, jeśli wybrano opcję Inni dostawcy)`
        }
      },
      serviceArea: {
        name: 'DODAJ OBSZARY USŁUG',
        sub: 'Nie dodano obszaru',
        description: `Dodaj swoje obszary działalności. Informacja ta jest potrzebna, aby firma Enphase mogła dopasować Cię do właścicieli domów, którzy są potencjalnymi klientami.`
      },
      qualifyLeads: {
        mainSection: 'Czy chcesz, aby konsultanci Enphase telefonicznie kwalifikowali potencjalnych klientów, zanim udostępnią Ci ich dane?',
        moreInfo: 'Poinformuj nas, jeśli chcesz, abyśmy zbierali konkretne rodzaje informacji o potencjalnych klientach.',
        infoWeCollect: 'Aby dowiedzieć się, jakie informacje zbieramy w ramach naszego procesu kwalifikacji',
        subSection: 'Czy chcesz, aby po kwalifikacji potencjalny klient został przełączony do jednego z Twoich konsultantów, bez rozłączania rozmowy z właścicielem domu?',
        details: 'Wybierz jednego z użytkowników administracyjnych ze swojej firmy, do którego powinni być kierowani tacy potencjalni klienci',
        icCheckList: 'Qualification Checklist',
        selectOption: 'Please select an option',
        selectUser: 'Please select a user',
      }
    },
    textContentAu: {
      preference: {
        title: 'Preferencje programu dot. potencjalnych klientów',
        caption: 'Wyłączenie odpowiedzialności',
        description: `Firma Enphase przedstawi właścicielom domów zakres cen podany przez Ciebie dla każdej z poniższych preferencji. Zostanie on przedstawiony z zastrzeżeniem, że wycena ma charakter informacyjny i odzwierciedla zakres prac tylko dla typowego systemu. Rzeczywista cena może ulec zmianie w zależności od lokalizacji, rodzaju/nachylenia dachu, standardu panelu elektrycznego i przeniesienia systemu w inne miejsce.`,
        atleaseOne: `* wybierz co najmniej jedną usługę`
      },
      programreview: {
        title: 'Przegląd programu',
        description: `Właściciele domów kontaktują się z firmą Enphase w sprawie nowych instalacji, modernizacji i bieżącej konserwacji systemu. Jako partner Enphase masz teraz możliwość obsługiwania tych właścicieli domów w ramach programu Enphase dot. potencjalnych klientów. Zapoznaj się z poniższymi kluczowymi warunkami i określ swoje preferencje dotyczące programu.`
      },
      keyProgramTerms: {
        title: 'Kluczowe warunki programu',
        enphaseProduct: 'W ramach programu należy stosować wyłącznie produkty Enphase',
        appointment: 'Firma Enphase pomoże w umawianiu spotkań i zapewni wsparcie w razie potrzeby',
        contact:
          'Od instalatorów wymaga się nawiązania kontaktu z każdym potencjalnym klientem w ciągu 2 dni roboczych',
        project:
          'Profil klienta i szczegóły projektu zostaną podane dla każdego potencjalnego klienta przed pierwszym kontaktem',
        verifiedAccount: 'Enphase bezpłatnie zapewni kwalifikujących się potencjalnych klientów z Twojego obszaru usług'
      },
      TurnKey: {
        title: 'Usługi kompleksowe',
        description: `Usługi kompleksowe oznaczają zapewnienie zestawienie materiałowego, projektu systemu, pozwoleń, instalacji i uruchomienia (w zależności od potrzeb). Instalator wykonuje projekt i dokonuje oceny lokalizacji przed dostarczeniem szczegółowej wyceny. Podana cena powinna zawierać całkowity szacunkowy koszt aktywacji systemu, jaki poniesie właściciel domu`,
        solar: {
          indicativePricing: 'Orientacyjny zakres cen za 1 W',
          quoteSizeIn: 'kW',
          main: 'System fotowoltaiczny – instalacja',
          sub: 'Nowa instalacja systemu fotowoltaicznego.',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Instalator',
              sub:
                'Zapewnia wycenę kompleksowej usługi i wymagane zestawienie materiałów, np. moduły, mikroinwertery, akcesoria, wyłączniki, modem komórkowy, kable i stelaże.'
            },
            assumptions: {
              main: 'Założenia',
              sub: `Przedział cenowy dotyczy typowej lokalizacji i nie obejmuje modernizacji panelu głównego i nietypowego dachu.`
            }
          }
        },
        storage: {
          indicativePricing: 'Orientacyjny zakres cen za 1 kWh',
          main: 'System magazynowania energii – instalacja',
          quoteSizeIn: 'kWh',
          sub: 'Nowa instalacja systemu magazynowania energii',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Instalator',
              sub:
                'Zapewnia wycenę kompleksowej usługi i wymagane zestawienie materiałów, np. urządzenie magazynujące ACB, stelaż, okablowanie i wyłączniki.'
            },
            assumptions: {
              main: 'Założenia',
              sub: `Orientacyjny przedział cenowy nie obejmuje modernizacji panelu głównego.`
            }
          }
        },
        microinverter: {
          indicativePricing: 'Orientacyjny zakres cen za 1 W',
          main: 'Mikroinwerter – modernizacja',
          quoteSizeIn: 'kW',
          sub:
            'Modernizacja mikroinwertera instalacji fotowoltaicznej opartej na serii M (np. M-215, M-250) do nowej instalacji fotowoltaicznej opartej na serii IQ, która zwykle towarzyszy opcji "System magazynowania energii – instalacja”',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Instalator',
              sub: 'Provides turn-key pricing and procures all required bill of material.'
            },
            assumptions: {
              main: 'Założenia',
              sub:
                'Orientacyjny przedział cenowy nie obejmuje modernizacji panelu głównego i modernizacji panelu słonecznego.'
            }
          }
        },
        solarExpansion: {
          indicativePricing: 'Orientacyjny zakres cen za 1 W',
          quoteSizeIn: 'kW',
          main: 'Rozbudowa systemu fotowoltaicznego',
          sub: 'Rozbudowa istniejących systemów fotowoltaicznych Enphase i innych niż Enphase',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Instalator',
              sub: 'Zapewnia wycenę systemu gotowego do użytku i wszystkie wymagane zestawienia materiałowe.'
            },
            assumptions: {
              main: 'Założenia',
              sub: `Przedział cenowy dotyczy typowej lokalizacji i nie obejmuje modernizacji panelu głównego i nietypowego dachu.`
            }
          }
        }
      },
      installationOnly: {
        title: 'Tylko usługi instalacyjne (dla programów specjalnych)',
        sub: '(np. systemy osierocone wymagające wymiany/naprawy, modernizacji akumulatorów czy bramy Envoy)',
        description:
          'Usługi tylko w zakresie instalacji oznaczają, że właściciel domu nabywa pozycje zestawienia materiałowego Enphase ze sklepu Enphase. Wszystkie inne materiały i usługi zapewnia bezpośrednio instalator (okablowanie, stelaże, projektowanie, zezwolenia, instalacja i uruchomienie, jeśli dotyczy).',
        solar: {
          quoteSizeIn: 'kW',
          indicativePricing: 'Orientacyjny zakres cen za 1 W za samą instalację',
          main: 'System fotowoltaiczny – instalacja',
          sub: `Nowe instalacje dla programów specjalnych, takich jak klienci z polecenia od innych klientów, instalatorów i pracowników Enphase.`,
          details: {
            homeOwner: {
              main: 'Właściciel domu',
              sub: `Nabywa wymagane pozycje zestawienia materiałowego ze sklepu Enphase, takie jak mikroinwertery, zestaw akcesoriów, brama Envoy i wyłączniki.`
            },
            installer: {
              main: 'Instalator',
              sub: 'Zapewnia moduły, stelaże, okablowanie, zezwolenia, instalację i uruchomienie.'
            },
            assumptions: {
              main: 'Założenia',
              sub: `Orientacyjny przedział cenowy nie obejmuje modernizacji panelu głównego i instalacji na nietypowym dachu.`
            }
          }
        },
        storage: {
          quoteSizeIn: 'kWh',
          indicativePricing: 'Orientacyjny zakres cen za 1 kWh za samą instalację',
          main: 'System magazynowania energii – rozbudowa lub instalacja',
          sub:
            'Rozbudowa lub instalacja urządzenia magazynującego ACB w istniejącym systemie fotowoltaicznym dla specjalnych programów',
          details: {
            homeOwner: {
              main: 'Właściciel domu',
              sub:
                'Kupuje wymagane pozycje zestawienia materiałowego ze sklepu Enphase, takie jak urządzenie ACB czy stelaże.'
            },
            installer: {
              main: 'Instalator',
              sub: 'Zapewnia instalację i uruchomienie.'
            },
            assumptions: {
              main: 'Założenia',
              sub: `Orientacyjny przedział cenowy nie obejmuje modernizacji panelu głównego.`
            }
          }
        },
        microinverter: {
          quoteSizeIn: 'kW',
          indicativePricing: 'Orientacyjny zakres cen za 1 W za samą instalację',
          main: 'Mikroinwertery – modernizacja',
          sub: `Modernizacja mikroinwerterów instalacji fotowoltaicznej opartej na urządzeniach M-190/M-210/M-175/D380 do nowej instalacji fotowoltaicznej opartej na serii IQ, która zwykle towarzyszy opcji "System magazynowania energii – instalacja"`,
          details: {
            homeOwner: {
              main: 'Właściciel domu',
              sub:
                'Nabywa wymagane pozycje zestawienia materiałowego ze sklepu Enphase, takie jak mikroinwertery, skrzynka Combiner IQ, zestaw akcesoriów i wyłączniki.​'
            },
            installer: {
              main: 'Instalator',
              sub: 'Zapewnia zezwolenia, wymianę, ponowne uruchomienie i recykling starych mikroinwerterów.'
            },
            assumptions: {
              main: 'Założenia',
              sub: `Orientacyjny przedział cenowy nie obejmuje modernizacji panelu głównego i zmian w stelażu.`
            }
          }
        }
      },
      omServices: {
        title: 'Usługi operacyjne i konserwacyjne Enphase',
        om: {
          main: 'Zgoda na świadczenie usług operacyjnych i konserwacyjnych Enphase',
          pre: '- Including Orphan Systems',
          sub: `Usługi operacyjne i konserwacyjne obejmują wsparcie i serwisowanie istniejących systemów Enphase oraz systemów osieroconych (lokalizacji z nieaktywnym instalatorem). Wszyscy potencjalni klienci zainteresowani usługami operacyjnymi i konserwacyjnymi otrzymają pełne informacje o lokalizacji i historię wsparcia. Wszystkich potencjalnych klientów zainteresowanych usługami operacyjnymi i konserwacyjnymi obowiązuje standardowa gwarancja produktowa firmy Enphase.`
        }
      },
      otherServices: {
        title: 'Pozostałe preferencje',
        buy: 'Interesuje mnie kupno produktów od',
        acModule: {
          main: 'Interesuje mnie instalacja modułów fotowoltaicznych AC Energized firmy Enphase',
          sub1: `Panele fotowoltaiczne AC Energized firmy Enphase `,
          sub2: `łączą w sobie najnowocześniejszą technologię mikroinwerterową firmy Enphase z wysokowydajnymi panelami słonecznymi. Produkt wyróżnia się estetyką i wydajnością. Ponadto skraca czas instalacji poprzez połączenie inwertera i panelu w pojedynczy zespół. Wybór tej opcji sprawi, że firma Enphase dopasuje Cię do właścicieli domów, którzy chcą zainstalować moduły AC.`
        },
        enstore: {
          main: 'Sklep Enphase',
          sub1: `Sklep Enphase `,
          sub2: `to punkt kompleksowej obsługi produktów do produkcji i magazynowania energii słonecznej, z gwarantowaną dostawą. Sklep nie wymaga minimalnej kwoty zamówienia i zapewnia informacje dotyczące dostawy w czasie rzeczywistym oraz śledzenie online.​`
        },
        distributor: {
          main: 'Dystrybutorzy Enphase',
          sub1: `Dystrybutorzy Enphase`,
          sub2: ` zapewniają wszystkie produkty firmy Enphase i inne akcesoria niezbędne dla Twojego systemu produkcji i magazynowania energii słonecznej.​`
        }
      },
      serviceArea: {
        name: 'DODAJ OBSZARY USŁUG',
        sub: 'Nie dodano obszaru',
        description: `Dodaj swoje obszary działalności. Informacja ta jest potrzebna, aby firma Enphase mogła dopasować Cię do właścicieli domów, którzy są potencjalnymi klientami.`
      }
    },
    getLink: 'Uzyskaj link',
    linkSENewLeads: 'Link do narzędzia do oceny kosztów systemu dla potencjalnych klientów',
    shareSELink:
      'Udostępnij ten link swoim klientom, aby pomóc im oszacować rozmiar systemu Enphase i przesłać ich dane, aby przekazać informacje o potencjalnym kliencie do swojego Enlighten Managera'
  }
};

export default leadPreferences;
